<div class="dialoghead">
    <h1 class="mat-mdc-dialog-title">Hey !</h1>
    <div class="login-info-mainwrapper"  *ngIf="logininfoList?.length">
        <div class="logininfowrapper" *ngFor="let loginlist of logininfoList">
            <p><strong>Email: </strong> <span>{{loginlist.email}}</span>    </p>
            <p><strong>Login Time: </strong> <span>{{loginlist.login_time | date:'EEEE, MMMM d, y, h:mm:ss a'}}</span>    </p>
            <p><strong>City: </strong> <span>{{loginlist.ipInfo?.city?loginlist.ipInfo?.city:'Na'}}</span>    </p>
            <p><strong>Country: </strong> <span>{{loginlist.ipInfo?.country?loginlist.ipInfo?.country:'Na'}}</span>    </p>
            <p><strong>Host Name: </strong> <span>{{loginlist.ipInfo?.hostname?loginlist.ipInfo?.hostname:'Na'}}</span>    </p>
            <p><strong>Ip: </strong> <span>{{loginlist.ipInfo?.ip?loginlist.ipInfo?.ip:'Na'}}</span>    </p>
            <p><strong>Isp Postal Region: </strong> <span>{{loginlist.ipInfo?.postal?loginlist.ipInfo?.postal:'Na'}}</span>    </p>
            <p><strong>Timezone: </strong> <span>{{loginlist.ipInfo?.timezone? loginlist.ipInfo?.timezone:'Na'}}</span>    </p>
        </div>
    </div>
    <div class="notfounddiv" *ngIf="!logininfoList?.length">        
        <p>Login Info Not Found</p>        
    </div>
    
    
</div>

<span mat-button mat-dialog-close class="close-btn-modal material-icons">close</span>

